import SearchIcon from '@mui/icons-material/Search';
import { Box, IconButton, TableCell, TableRow, Typography } from '@mui/material';
import { PublicAuditLog } from 'api';
import { MAX_CHANGED_PAYLOAD_LENGTH } from 'pages/AuditLogs/constants';
import { formatChangedPayload } from 'pages/AuditLogs/utilities';

const LogRow = ({ log, onExpandHandler }: { log: PublicAuditLog; onExpandHandler: () => void }) => {
  const formatted = formatChangedPayload(log.changed_payload);
  const isLong = formatted.length > MAX_CHANGED_PAYLOAD_LENGTH;
  return (
    <TableRow key={`${log.created_at}-${log.id}-tablerow`}>
      <TableCell>{new Date(log.created_at).toLocaleString()}</TableCell>
      <TableCell>{log.user ? `${log.user.first_name} ${log.user.last_name}` : null}</TableCell>
      <TableCell>{log.domain_area}</TableCell>
      <TableCell>{`${log.model} #${log.record_id}`}</TableCell>
      <TableCell>{log.mutation_type}</TableCell>
      <TableCell sx={{ width: '20%', maxWidth: '20%' }}>
        <Box display="flex" alignItems="center" gap={0.5}>
          <Typography
            variant="body2"
            noWrap
            sx={{
              flex: 1,
              minWidth: 0,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}>
            {formatted}
          </Typography>
          {isLong && (
            <IconButton
              size="small"
              onClick={onExpandHandler}
              sx={{ padding: 0.5, flexShrink: 0 }}
              title="View full details">
              <SearchIcon fontSize="small" />
            </IconButton>
          )}
        </Box>
      </TableCell>
    </TableRow>
  );
};

export default LogRow;
